import { ref } from 'vue'

export const isNavbarVisible = ref(false)
